import styled from '@xstyled/styled-components'

export const PageMain = styled.main`
  padding: 2;
  display: flex;
  justify-content: space-between;
  align-items: start;
  min-height: 75vh;
  position: relative;
  &.about {
    background-color: mustard;
  }
  &.projects {
    background-color: mustard;
  }
  &.news {
    background-color: var(--two);
  }
  &.contact {
    background-color: var(--two);
  }
  @media screen and (max-width: 1024px) {
    padding: 4;
  }
  @media screen and (max-width: 768px) {
    padding: 2 4;
    min-height: calc(100vh - 304px);
  }
`

export const PageInner = styled.div`
  z-index: 1;
  margin: 0 auto;
  padding: 0 6 9 6;
  max-width: 1280px;
  text-align: center;
  width: 100%;
  h1 {
    font-family: var(--sans);
    font-size: 96px;
    text-transform: uppercase;
  }
  > p {
    line-height: 50px;
    letter-spacing: -1.5px;
    font-size: 36px;
    margin-bottom: 4;
  }
  @media screen and (max-width: 1024px) {
    padding: 4 1;
    max-width: 570px;
    p {
      font-size: 20px;
      line-height: 1.33;
      letter-spacing: -0.75px;
    }
  }
  &.about-inner {
    padding-bottom: 70vh;
    position: relative;
    padding-top: 24px;
    h1 {
      text-align: right;
    }
    h1 img {
      position: absolute;
      left: 0;
      top: 4rem;
    }
    p {
      text-align: center;
      margin-top: 0;
    }
  }
  @media screen and (max-width: 1024px) {
    h1 {
      font-size: 2;
      img {
        width: 50px;
        height: 40px;
      }
    }
    p {
      font-size: 5;
      margin-bottom: 2;
    }
    &.about-inner {
      padding-bottom: 10;
      h1 {
        text-align: center;
      }
      h1 img {
        position: absolute;
        left: 1rem;
        width: 55px;
        top: 0rem;
      }
      p {
        text-align: center;
        max-width: 480px;
      }
    }
  }
  @media screen and (max-width: 640px) {
    &.about-inner {
      padding: 3;
      padding-top: 0px;
    }
  }
`

export const PageFooter = styled.div`
  display: block;
  position: absolute;
  bottom: -50px;
  width: 80%;
  margin: 0 auto;
  left: 0px;
  right: 0px;
  z-index: 0;
  padding-bottom: 16px;
  #baby {
    fill: #e04343;
  }
`
